<template>
    <nav
      class="main-nav"
      :class="{
        'not-drawer' : !isDrawer,
        'collapsed' : collapsed
      }"
      v-closable="{
        exclude: ['actionToggleMenu'],
        shouldCheck: visible,
        handler: 'hide'
      }"
    >
      <div class="scrollbox">
        <div class="scrollbox-content">
          <div class="d-flex align-items-center justify-content-start pt-3 px-3 logo-wrap">
            <button
              type="button"
              class="toggle mr-3 mr-md-4 actionToggleMenu"
              @click="$emit('toggle-main-sidebar', $event)"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <div class="logo">
              <router-link to="/">
                <img src="/images/layout/logo.png" alt="Scriv" />
              </router-link>
            </div>
          </div>

          <hr
            class="background-color2 h-1 not-drawer-visible"
          />

          <ul>
            <li v-if="1 == 2">
              <router-link
                :to="{ name: 'events.show.09-terror' }"
                title="Evento"
                class="with-mark"
                :class="{
                  'hide-mark': clickedItems.includes('events')
                }"
                @click.native="clickLink('events')"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <TrophyIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Evento
                </span>
              </router-link>
            </li>
            <!-- <li
              v-if="user"
            >
              <router-link
                :to="{ name: 'landing-pages.scriv-pro' }"
                title="Scriv PRO"
                class="with-mark"
                :class="{
                  'hide-mark': clickedItems.includes('scriv-pro')
                }"
                @click.native="clickLink('scriv-pro')"
              >
                <span class="icon-wrap">
                  <span class="icon icon-basic text-color2 font-size-regular">
                    <i class="fa fa-diamond"></i>
                  </span>
                </span>
                <span class="text">
                  Scriv Pro
                </span>
              </router-link>
            </li> -->
            <li>
              <router-link
                :to="{ name: 'books.index' }"
                title="Biblioteca"
              >
                <span class="icon-wrap">
                  <span class="icon-basic text-color2">
                    <i class="fa fa-book font-size-regular"></i>
                  </span>
                </span>
                <span class="text">
                  Biblioteca
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'groups.index' }"
                title="Comunidades"
              >
                <span class="icon-wrap">
                  <span class="icon-basic text-color2">
                    <i class="fas fa-campground"></i>
                  </span>
                </span>
                <span class="text">
                  Comunidades
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'landing-pages.public-domain' }"
                title="Clássicos"
                class="with-mark"
                :class="{
                  'hide-mark': clickedItems.includes('classics')
                }"
                @click.native="clickLink('classics')"
              >
                <span class="icon-wrap">
                  <span class="icon-basic text-color2">
                    <i class="fa fa-file-text-o font-size-regular"></i>
                  </span>
                </span>
                <span class="text">
                  Clássicos
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                to="/"
                title="Início"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <HomeIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Início
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'feed.show', params: { type: 'latest' } }"
                title="Mais Recentes"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <CalendarIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Mais Recentes
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'feed.show', params: { type: 'trending' } }"
                title="Populares"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <FireIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Populares
                </span>
              </router-link>
            </li>
            <li
              v-if="user"
            >
              <router-link
                :to="{ name: 'feed.following' }"
                title="Que eu sigo"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <UsersIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Que eu sigo
                </span>
              </router-link>
            </li>
            <!-- <li
              v-if="user && user.is_scriv_pro_enabled"
            >
              <router-link
                :to="{ name: 'advanced-analytics.general.show' }"
                class="with-mark"
                title="Estatísticas Avançadas"
                :class="{
                  'hide-mark': clickedItems.includes('advanced-analytics')
                }"
                @click.native="clickLink('advanced-analytics')"
              >
                <span class="icon-wrap">
                  <span class="icon icon-basic text-color2">
                    <i class="fa fa-bar-chart"></i>
                  </span>
                </span>
                <span class="text">
                  Estatísticas Avançadas
                </span>
              </router-link>
            </li> -->
          </ul>

          <hr class="background-color2 h-1" />

          <ul>
            <li>
              <router-link
                :to="{ name: 'categories.index' }"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <TagIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Minhas categorias
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'users.ongoing' }"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <OngoingIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Continuar lendo
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'users.drafts' }"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <PencilIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Rascunhos
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'lists.show', params: { username: user ? user.username : 'username', slug: user ? user.readlater_list.slug : 'readlater' } }"
                title="Populares"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <BaseIcon
                    size="small"
                  >
                    <ClockIcon />
                  </BaseIcon>
                </span>
                <span class="text">
                  Ler mais tarde
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'lists.index' }"
                title="Minhas listas"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <span class="icon-basic text-color2">
                    <i class="fa fa-list"></i>
                  </span>
                </span>
                <span class="text">
                  Minhas listas
                </span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'users.groups.index' }"
                title="Minhas comunidades"
                @click.native="clickLink"
              >
                <span class="icon-wrap">
                  <span class="icon-basic text-color2">
                    <i class="fas fa-campground"></i>
                  </span>
                </span>
                <span class="text">
                  Minhas comunidades
                </span>
              </router-link>
            </li>
          </ul>

          <!-- FOOTER LINKS -->
          <template v-if="!collapsed">
            <hr class="background-color2 h-1" />
            <ul class="footer-links">
              <li class="">
                <router-link
                  :to="{ name: 'statics.about' }"
                >
                  Sobre
                </router-link>
              </li>
              <li class="">
                <router-link
                  :to="{ name: 'statics.wallet' }"
                >
                  Wallet
                </router-link>
              </li>
              <li class="">
                <router-link
                  :to="{ name: 'statics.contact' }"
                >
                  Contato
                </router-link>
              </li>
              <li class="">
                <router-link
                  :to="{ name: 'statics.faq' }"
                >
                  Perguntas Frequentes
                </router-link>
              </li>
              <li class="">
                <router-link
                  :to="{ name: 'statics.privacy' }"
                >
                  Privacidade
                </router-link>
              </li>
              <li class="">
                <router-link
                  :to="{ name: 'statics.moderation' }"
                >
                  Moderação
                </router-link>
              </li>
              <li class="">
                <router-link
                  :to="{ name: 'statics.terms' }"
                >
                  Termos
                </router-link>
              </li>
            </ul>
          </template> <!-- END FOOTER  LINKS -->
        </div>
      </div>
    </nav>
</template>

<script>

import { mapState } from 'vuex'

import BaseIcon from '@/components/common/Icon/BaseIcon'
import CalendarIcon from '@/components/common/Icon/CalendarIcon'
import ClockIcon from '@/components/common/Icon/ClockIcon'
import FireIcon from '@/components/common/Icon/FireIcon'
import HomeIcon from '@/components/common/Icon/HomeIcon'
import OngoingIcon from '@/components/common/Icon/OngoingIcon'
import PencilIcon from '@/components/common/Icon/PencilIcon'
import TagIcon from '@/components/common/Icon/TagIcon'
import TrophyIcon from '@/components/common/Icon/TrophyIcon'
import UsersIcon from '@/components/common/Icon/UsersIcon'

export default {
  name: 'TheMainSidebar',
  props: ['visible'],
  components: {
    BaseIcon,
    CalendarIcon,
    ClockIcon,
    FireIcon,
    HomeIcon,
    OngoingIcon,
    PencilIcon,
    TagIcon,
    TrophyIcon,
    UsersIcon
  },
  data () {
    return {
      clickedItems: []
    }
  },
  computed: {
    ...mapState({
      collapsed: state => state.isMainSidebarCollapsed
    }),
    ...mapState('users', {
      user: state => state.user
    }),
    isDrawer () {
      const routeName = this.$route.name
      const routes = ['posts.create', 'posts.edit', 'posts.show', 'books.create', 'books.edit', 'chapters.show']
      return routes.includes(routeName)
    }
  },
  methods: {
    hide () {
      if ((this.isDrawer && this.visible) || (this.visible && window.innerWidth < 992)) {
        this.$emit('toggle-main-sidebar', true)
      }
    },
    clickLink (target = null) {
      this.hide()

      if (target) {
        this.clickedItems.push(target)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

nav {
  &.main-nav {
    position: fixed;
    top: 0;
    left: -240px;
    height: 100%;
    width: 240px;
    z-index: 12;
    background: #fff;
    transition: all 0.2s ease-out;

    &.not-drawer {
      @include desktop {
        left: 0;
        top: 80px;
        height: calc(100% - 80px);
        z-index: 2;
        transition: none;
      }

      .scrollbox {
        overflow: auto;
        visibility: hidden;
        height: 100%;
        padding-top: 10px;
        scrollbar-color: #EA6C54 #fff;
        scrollbar-width: thin;

        /* width */
        &::-webkit-scrollbar {
          width: 10px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: #fff;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #EA6C54;
          border: 2px solid #fff;
          -webkit-border-radius: 5px;
        }
      }

      .scrollbox-content, .scrollbox:hover, .scrollbox:focus {
        visibility: visible;
      }

      .not-drawer-visible {
        @include desktop {
          display: none;
        }
      }

      .logo-wrap {
        @include desktop {
          display: none !important;
        }
      }

      // Collapsed
      &.collapsed {
        @include desktop {
          width: 80px;
        }

        ul {
          li {
            a {
              @include desktop {
                white-space: initial;
                overflow: visible;
                text-overflow: clip;
                height: auto;
                text-align: center;
                padding: 10px 10px;
              }

              &.with-mark {
                .icon {
                  &::before {
                    right: -8px;
                    left: auto;
                  }
                }
              }

              &.hide-mark {
                .icon {
                  &::before {
                    display: none !important;
                  }
                }
              }

              .icon-wrap {
                @include desktop {
                  display: block;
                  line-height: 1;
                  margin-bottom: 5px;
                }
              }
              .text {
                @include desktop {
                  display: block;
                  font-size: $font_size_xxSmall;
                  line-height: 1;
                }
              }
            }
          }
        }
      }
    }

    &.active {
      left: 0;
    }

    .logo {
      img {
        width: 100px;
      }
    }

    .toggle {
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
      border: none;
      background: transparent;
      padding: 10px;
      margin-top: 6px;

      &:hover {
        span {
          background: $color2;
        }
      }

      span {
        display: block;
        width: 20px;
        height: 2px;
        background: $color1;
        margin-bottom: 4px;
        transition: all 0.2s ease-out;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    ul:not(.footer-links) {
      li {
        display: block;

        a {
          color: $color1;
          display: block;
          padding: 0 24px;
          height: 40px;
          line-height: 40px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &:hover {
            background: $color2;
            color: #fff;
          }
          &.with-mark {
            .icon {
              position: relative;
              &::before {
                content: '\f12a';
                font-family: 'FontAwesome';
                position: absolute;
                top: -8px;
                left: -8px;
                font-size: 11px;
                color: #fff;
                border-radius: 30px;
                width: 15px;
                height: 15px;
                background: $color2;
                line-height: 15px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
}

nav.main-nav ul:not(.footer-links) li  {
  font-size: $font_size_small;

  a {
    &:hover {
      ::v-deep {
        .color {
          fill: #fff;
        }
      }
      .icon-basic {
        color:#fff;
      }
    }

    .icon-basic {
      display: inline-block;
      width: 28px;
      padding-left: 5px;;
      transition: all 0.2s ease-out;
    }
  }

}

.footer-links {
  padding: 0 24px;
  display: flex;
  flex-wrap: wrap;

  li {
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }
  }

  a {
    font-size: $font_size_xSmall;
    color: $color1;

    &:hover {
      color: $color2;
    }
  }
}
</style>
